module.exports = __webpack_public_path__ + "img/HomePage.5a5bc6d6.png";